import { subWeeks, format, parse } from 'date-fns';

// ✅ Calculate pitch due date: 2 weeks before release date
export const calculatePitchDueDate = (releaseDateStr: string): string => {
  // Parse the input date string (expected ISO format)
  const releaseDate = parse(releaseDateStr, 'yyyy-MM-dd', new Date());

  // Subtract 2 weeks from the release date
  const pitchDueDate = subWeeks(releaseDate, 2);

  // Format the result as MM/dd/yy
  return format(pitchDueDate, 'MM/dd/yy');
};

// ✅ Format any date string to MM/dd/yy for display
export const formatDisplayDate = (dateStr: string): string => {
  try {
    let date = parse(dateStr, 'yyyy-MM-dd', new Date());
    if (isNaN(date.getTime())) {
      date = new Date(dateStr);
    }
    if (isNaN(date.getTime())) throw new Error();
    return format(date, 'MM/dd/yy');
  } catch {
    return 'Invalid Date';
  }
};

// ✅ Convert from dd/MM/yy to ISO (yyyy-MM-dd)
export const toISODate = (dateStr: string): string => {
  // If input is dd/MM/yy, convert to ISO
  if (/^\d{2}\/\d{2}\/\d{2}$/.test(dateStr)) {
    const date = parse(dateStr, 'dd/MM/yy', new Date());
    return format(date, 'yyyy-MM-dd');
  }

  // If already ISO, return as is
  return dateStr;
};

export const mmddyyToISO = (dateStr: string): string => {
  // Parse MM/DD/YY and format to ISO
  const date = parse(dateStr, 'MM/dd/yy', new Date());
  return format(date, 'yyyy-MM-dd');
};

// Usage:
// const isoDate = mmddyyToISO("08/15/25"); // "2025-08-15"

